import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import SubHeader from '../../../../components/ImportDesktopFile/Toast/SubHeader';
import * as selectors from '../selectors';

const mapStateToProps = (state: StoreState) => {
	const { importManager: { remainingImportTime } } = state;
	const filesToDisplay = selectors.getFilesToDisplay(state);
	const importedFilesNumber = selectors.getImportedFilesNumber(state);
	const filesWithErrorNumber = selectors.getFilesWithErrorNumber(state);
	const canceledFilesNumber = selectors.getCanceledFilesNumber(state);
	const notImportedFiles = filesToDisplay.length - filesWithErrorNumber;

	const isDisplayed = importedFilesNumber < notImportedFiles;
	const isRestartAllEnabled = notImportedFiles - importedFilesNumber === canceledFilesNumber;

	return {
		isDisplayed,
		isRestartAllEnabled,
		files: selectors.getFilesToDisplay(state),
		remainingImportTime: Math.ceil(remainingImportTime),
	};
};

export default connect(mapStateToProps)(SubHeader);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/Toast/SubHeader/index.tsx